import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "./ConfirmDialog";

// Imperative handle so non-component code (helpers/swalErrorPopup.js) can open
// the dialog — same pattern as v2/routerRef.js. Concurrent failing calls just
// overwrite the message; a single dialog is always shown.
let showRef = null;

// Opens the V2 error dialog. Returns false when the host isn't mounted so the
// caller can fall back to the legacy Swal popup.
export const showErrorDialog = (mess) => {
  if (!showRef) return false;
  showRef(mess);
  return true;
};

// Customer-service number, same as v2/screens/connectionError/ConnectionError.jsx.
const WHATSAPP_CUSTOMER_SERVICE_URL = "https://wa.me/972559458809";

// App-wide error dialog (V2 design), mounted once in index.jsx alongside the
// router. A server message renders alone (no generic title); errors without a
// message get the generic "oops" title + body.
function ErrorDialogHost() {
  const { t } = useTranslation();
  const [state, setState] = useState({ isOpen: false, mess: "" });

  useEffect(() => {
    showRef = (mess) => setState({ isOpen: true, mess: mess || "" });
    return () => {
      showRef = null;
    };
  }, []);

  const close = () => setState((s) => ({ ...s, isOpen: false }));

  const openWhatsapp = () => {
    window.open(WHATSAPP_CUSTOMER_SERVICE_URL, "_blank");
    close();
  };

  return (
    <ConfirmDialog
      isOpen={state.isOpen}
      onClose={close}
      title={state.mess ? "" : t("ERROR_POPUP_TITLE")}
      body={state.mess || t("ERROR_POPUP_BODY")}
      primaryText={t("ERROR_POPUP_CONFIRM")}
      onPrimary={close}
      secondaryText={t("ERROR_POPUP_WHATSAPP")}
      onSecondary={openWhatsapp}
    />
  );
}

export default ErrorDialogHost;
